"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getSessionToken_1 = __importDefault(require("../../../utils/login/getSessionToken"));
/**
 * Client interface to make Payment checkout API call for pay by card
 * @param {CardCheckoutParamType} reqParam
 * @param {string} extensionId
 * @returns {Promise}
 */
const payByCardExtension = (reqParam, extensionId) => {
    const requestId = 'PAY_BY_CARD_EXTENSION';
    const sessionToken = (0, getSessionToken_1.default)();
    const config = {
        data: reqParam,
    };
    if (sessionToken) {
        config.headers = {
            Authorization: `Bearer ${sessionToken}`,
        };
    }
    const rawEndpoint = ENDPOINTS_1.default.BOOKING_SERVICE.PAYMENT_EXTENSION;
    const endPoint = rawEndpoint.replace('{extensionId}', extensionId);
    return http_service_1.default
        .post(requestId, endPoint, config)
        .then((response) => response.data);
};
exports.default = payByCardExtension;
